module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("To my late Mom and Dad,")]), _vm._v(" "), _c('p', [_vm._v("I conceived the idea of writing this book to honor you,")]), _vm._v(" "), _c('p', [_vm._v("But you were called to your Maker,")]), _vm._v(" "), _c('p', [_vm._v("Long before I even began the writing process.")]), _vm._v(" "), _c('p', [_vm._v("The writing is now over,")]), _vm._v(" "), _c('p', [_vm._v("And here is the book,")]), _vm._v(" "), _c('p', [_vm._v("It’s yours, Mom and Dad,")]), _vm._v(" "), _c('p', [_vm._v("In memory of your sacrifices and dedication to my upbringing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1ba640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0